import axios from "axios";

const remove = (id) => axios.delete(`images/${id}`);
export default remove;
